import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAnimation } from '../contexts/AnimationContext';

interface AnimatedLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const AnimatedLink: React.FC<AnimatedLinkProps> = ({ to, children, className, onClick }) => {
  const { startTransition } = useAnimation();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Only trigger animation for login/register transitions
    if ((to === '/register' && window.location.pathname === '/login') ||
        (to === '/login' && window.location.pathname === '/register')) {
      
      // Determine animation direction
      const direction = to === '/register' ? 'right' : 'left';
      
      // Start the transition immediately
      startTransition(direction);
      
      // Navigate after a short delay to allow animation to start
      setTimeout(() => {
        navigate(to);
      }, 100);
    } else {
      // Regular navigation for other routes
      navigate(to);
    }
    
    // Call custom onClick if provided
    if (onClick) {
      onClick();
    }
  };

  return (
    <Link to={to} className={className} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default AnimatedLink; 